import React from 'react';

export default function Carousel({ variety, limit, layout }) {
  return (
    <div>
      {variety ? `${variety}, ` : null} {limit ? `${limit}` : null} {layout ? `, ${layout}` : null}
    </div>
  );
}
